import styled from "styled-components";

export const Wrapper = styled.button`
  margin: 2rem auto;
  padding: 1rem 2rem;
  background-color: var(--text-color);
  color: var(--background-color);
  border: solid 2px var(--text-color);
  cursor: pointer;
  font-size: large;
  font-weight: 500;
  transition: all 0.1s ease-in;

  :hover {
    color: var(--text-color);
    background-color: var(--background-color);
    box-shadow: 0px 2px 8px 1px rgba(0, 0, 0, 0.7);
    -webkit-box-shadow: 0px 2px 8px 1px rgba(0, 0, 0, 0.7);
    -moz-box-shadow: 0px 2px 8px 1px rgba(0, 0, 0, 0.7);
  }
`;
